module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/bg_03-14f88f6a243ce0378efa25b8a7690917.png";